// extracted by mini-css-extract-plugin
module.exports = {"aveliosButton":"avelios-button_aveliosButton__B8HoA"};